import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "311",
  "slug": "spot-sweden-from-satellite-imagery",
  "title": "How to Recognise Sweden in Satellite Images",
  "excerpt": "Sweden has a long Baltic coastline and a largely forested interior, with more extensive agriculture in the south.",
  "date": "2026-03-22",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/sweden.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Sweden has a long Baltic coastline and a largely forested interior, with more extensive agriculture in the south. Vänern and Vättern stand out as large inland water bodies. Mountains rise along the western border with Norway, while much of the east has lower relief."
    },
    {
      "type": "heading",
      "text": "Large lakes and a forested interior"
    },
    {
      "type": "paragraph",
      "text": "Locate Vänern and Vättern, then compare southern farmland with the forested country farther north."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Finland also has forest and lakes. Norway shares the Scandinavian mountains. A close view of conifers or a small lake may be ambiguous, so compare the outline of a larger water body and nearby terrain."
    }
  ],
  "imageAlt": "Sweden regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
